var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-upload", on: { click: _vm.handleClick } },
    [
      _vm.drag
        ? _c(
            "dragger",
            {
              attrs: { disabled: _vm.disabled, "icon-class": _vm.iconClass },
              on: { file: _vm.uploadFiles },
            },
            [_vm._t("default"), _vm._t("tip", null, { slot: "tip" })],
            2
          )
        : _vm._t("default"),
      _c("form", { ref: "form", staticClass: "yxtbiz-upload__input" }, [
        _c("input", {
          ref: "input",
          attrs: { type: "file", multiple: _vm.multipe, accept: _vm.accept },
          on: { change: _vm.handleFileChange },
        }),
      ]),
      _vm.disabled
        ? _c("div", { staticClass: "yxtbiz-upload--disabled" })
        : _vm._e(),
      _c(
        "yxt-dialog",
        {
          attrs: {
            title: _vm.$t("pc_biz_uploadimg_btn_upload").d("上传附件"),
            visible: _vm.uploadSettingDialogVisible,
            width: "480px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.uploadSettingDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { height: "200px" } },
            [
              _c("div", [
                _vm._v(_vm._s(_vm.$t("pc_biz_kng_lbl_upload_to").d("上传到"))),
              ]),
              _vm.customSelectUploadEnv === 2
                ? _c(
                    "yxt-radio-group",
                    {
                      staticStyle: { "margin-bottom": "20px" },
                      model: {
                        value: _vm.uploadCloudRadio,
                        callback: function ($$v) {
                          _vm.uploadCloudRadio = $$v
                        },
                        expression: "uploadCloudRadio",
                      },
                    },
                    [
                      _c("yxt-radio", { attrs: { label: 0 } }, [
                        _vm._v(
                          _vm._s(
                            _vm
                              .$t("pc_kng_courseware_lbl_public_cloud")
                              .d("公有云")
                          )
                        ),
                      ]),
                      _c("yxt-radio", { attrs: { label: 1 } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("pc_biz_kng_tip_localCloud").d("私有云")
                          )
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.uploadCloudRadio === 1 &&
              _vm.groupListRes &&
              _vm.groupListRes.serviceGroupList
                ? _c(
                    "div",
                    { staticStyle: { "background-color": "#fafafa" } },
                    [
                      _c(
                        "yxt-radio-group",
                        {
                          model: {
                            value: _vm.selectLocalServiceId,
                            callback: function ($$v) {
                              _vm.selectLocalServiceId = $$v
                            },
                            expression: "selectLocalServiceId",
                          },
                        },
                        _vm._l(
                          _vm.groupListRes.serviceGroupList,
                          function (item, index) {
                            return _c(
                              "yxt-radio",
                              { key: index, attrs: { label: item.id } },
                              [_vm._v(_vm._s(item.serviceGroupName))]
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "yxt-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.uploadSettingDialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("pc_biz_labelling_cancel").d("取消")))]
              ),
              _c(
                "yxt-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleUploadSetting },
                },
                [_vm._v(_vm._s(_vm.$t("pc_biz_labelling_confirm").d("确定")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }